import DesignEditorLoadingIndicator from './DesignEditorLoadingIndicator';

export default DesignEditorLoadingIndicator;
